import classNames from "classnames"
import { Button } from "primereact/button"
import { Dialog } from "primereact/dialog"
import React from "react"
import { FaArrowLeft, FaCheck } from "react-icons/fa"
import { formatCurrency } from "../../../utils/formatCurrency"

function AcceptPropostaDialog({ negotiateInfo, close, accept }) {

    const footer = (
        <div className="flex justify-center w-full gap-2">
            <Button
                label={negotiateInfo.acao === 'CONTRA-PROPOSTA' ? 'Enviar' : 'Negociar'}
                icon={<FaCheck className="mr-2" />}
                severity="success"
                onClick={() => accept()}
            />
            <Button
                label="Voltar"
                icon={<FaArrowLeft className="mr-2" />}
                severity="danger"
                onClick={() => close()}
            />
        </div>
    )

    return (
        <Dialog
            visible
            onHide={() => close()}
            header="Confirmação"
            footer={footer}
            pt={{
                root: 'max-w-screen lg:max-h-[80vh]',
                headerTitle: 'font-bold text-xl w-full text-center',
                content: ({ state }) => ({
                    className: classNames('overflow-auto w-full max-h-[80vh]',
                        'bg-white text-gray-700 px-6 pb-8 pt-0',
                        //'rounded-bl-lg rounded-br-lg',
                        'dark:bg-gray-900 dark:text-white/80 ', {
                        "grow": state.maximized
                    })
                }),
            }}
        >
            <div className="text-center grid">
                <h4 className="text-lg mb-2"><b>{negotiateInfo.mensagem_dialog}</b></h4>
                <div >
                    <h5><b>Valor Total:</b> {formatCurrency(negotiateInfo.valorTotal)}</h5>
                    <h5><b>Valor Proposto:</b> {formatCurrency(negotiateInfo.valorAPagar)}</h5>
                    <h5><b>Diferença:</b> {formatCurrency(negotiateInfo.desconto)}</h5>
                    {negotiateInfo.entrada > 0 && <h5><b>Entrada:</b> {formatCurrency(negotiateInfo.entrada)}</h5>}
                    <h5><b>Valor Direto:</b> {formatCurrency(negotiateInfo.valorPague + negotiateInfo.valorProtesto)}</h5>
                    <h5><b>Valor a Receber:</b> {formatCurrency(negotiateInfo.valorProvider)}</h5>
                    <h5><b>Número de Parcelas:</b> {negotiateInfo.entrada > 0 && '1 +'} {negotiateInfo.parcelas}</h5>
                </div>
            </div>
        </Dialog>
    )
}

export default AcceptPropostaDialog